import { Toast } from 'buefy/dist/components/toast';

// eslint-disable-next-line import/prefer-default-export
export const lsToastService = {
    open({ message, type, ...props }) {
        Toast.open({
            duration: 3000,
            message,
            position: 'is-bottom',
            type,
            ...props,
        });
    },
};
